import { ErrorIcon, PlayIcon, PauseIcon, RemoveIcon } from '@imus/base-ui';
import React from 'react';
export { HelpIcon } from '@imus/base-ui';

export const Leave = ({
  className,
  style,
  fill = 'var(--on-surface)',
}: {
  className?: string;
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    className={className}
    style={style}
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.16667 8L2.5 12M2.5 12L6.16667 16M2.5 12L14.5 12M20.5 19V5"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Lock = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    style={style}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C9.51472 2 7.5 4.01472 7.5 6.5V9.14494C6.05426 9.57521 5 10.9145 5 12.5V17.5C5 19.433 6.567 21 8.5 21H15.5C17.433 21 19 19.433 19 17.5V12.5C19 10.9145 17.9457 9.57521 16.5 9.14494V6.5C16.5 4.01472 14.4853 2 12 2ZM14.5 9V6.5C14.5 5.11929 13.3807 4 12 4C10.6193 4 9.5 5.11929 9.5 6.5V9H14.5Z"
      fill="black"
      fillOpacity="0.95"
    />
  </svg>
);

export const Subscription = ({
  className,
  style,
  fill = 'white',
}: {
  className?: string;
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    className={className}
    style={style}
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2007 7.00001C18.3759 6.60174 18.9409 6.60174 19.1161 7.00001L20.2602 9.60124C20.3106 9.71577 20.402 9.80725 20.5166 9.85762L23.1178 11.0017C23.5161 11.1769 23.5161 11.7419 23.1178 11.9171L20.5166 13.0612C20.402 13.1115 20.3106 13.203 20.2602 13.3175L19.1161 15.9188C18.9409 16.317 18.3759 16.317 18.2007 15.9188L17.0567 13.3175C17.0063 13.203 16.9148 13.1115 16.8003 13.0612L14.199 11.9171C13.8008 11.7419 13.8008 11.1769 14.199 11.0017L16.8003 9.85762C16.9148 9.80725 17.0063 9.71577 17.0567 9.60124L18.2007 7.00001Z"
      fill={fill}
    />
    <path
      d="M6.20078 1.35647C6.37595 0.958204 6.94099 0.958204 7.11616 1.35647L8.41297 4.30496C8.46335 4.41949 8.55483 4.51097 8.66936 4.56135L11.6179 5.85816C12.0161 6.03333 12.0161 6.59837 11.6179 6.77354L8.66936 8.07035C8.55483 8.12073 8.46335 8.21221 8.41297 8.32674L7.11616 11.2752C6.94099 11.6735 6.37595 11.6735 6.20079 11.2752L4.90397 8.32674C4.8536 8.21221 4.76211 8.12073 4.64758 8.07035L1.69909 6.77354C1.30082 6.59837 1.30082 6.03333 1.69909 5.85816L4.64758 4.56135C4.76211 4.51097 4.8536 4.41949 4.90397 4.30496L6.20078 1.35647Z"
      fill={fill}
    />
    <path
      d="M10.1161 14.5812C9.94094 14.183 9.3759 14.183 9.20073 14.5812L8.20939 16.8352C8.15901 16.9497 8.06753 17.0412 7.953 17.0916L5.69904 18.0829C5.30077 18.2581 5.30077 18.8231 5.69904 18.9983L7.953 19.9897C8.06753 20.04 8.15901 20.1315 8.20939 20.246L9.20073 22.5C9.3759 22.8983 9.94094 22.8983 10.1161 22.5L11.1075 20.246C11.1578 20.1315 11.2493 20.04 11.3638 19.9897L13.6178 18.9983C14.0161 18.8231 14.0161 18.2581 13.6178 18.0829L11.3638 17.0916C11.2493 17.0412 11.1578 16.9497 11.1075 16.8352L10.1161 14.5812Z"
      fill={fill}
    />
  </svg>
);

export const Bell = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2.25C11 1.69772 11.4477 1.25 12 1.25C12.5523 1.25 13 1.69772 13 2.25V3.00773C13.2202 3.01443 13.3944 3.02694 13.5578 3.0503C15.4226 3.31681 16.9793 4.60879 17.5849 6.39254C17.6992 6.72915 17.7733 7.12421 17.9214 7.91432L20 19H4L6.07856 7.91436C6.22671 7.12423 6.30078 6.72916 6.41507 6.39254C7.02068 4.60879 8.57742 3.31681 10.4422 3.0503C10.6056 3.02694 10.7798 3.01443 11 3.00773V2.25ZM17.5901 17H6.40985L8.0443 8.28294C8.20444 7.42887 8.25157 7.20436 8.3089 7.03552C8.67226 5.96527 9.60631 5.19009 10.7252 5.03018C10.9017 5.00495 11.131 5 12 5C12.869 5 13.0983 5.00495 13.2748 5.03018C14.3937 5.19009 15.3277 5.96527 15.6911 7.03552C15.7484 7.20435 15.7956 7.42886 15.9557 8.28289L17.5901 17Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      d="M14 20.25V20.75C14 21.8546 13.1046 22.75 12 22.75C10.8954 22.75 10 21.8546 10 20.75V20.25H14Z"
      fill="black"
      fillOpacity="0.8"
    />
  </svg>
);

export const BellMuted = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5879 11.6547L18.3015 9.94117L20 19H9.24266L11.2427 17H17.5902L16.5879 11.6547Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      d="M6.07858 7.91436L4.74832 15.0091L7.25276 12.5046L8.04432 8.28294C8.20446 7.42887 8.25159 7.20436 8.30891 7.03552C8.67228 5.96527 9.60633 5.19009 10.7252 5.03018C10.9017 5.00495 11.1311 5 12 5C12.869 5 13.0983 5.00495 13.2748 5.03018C13.6619 5.08549 14.0268 5.21443 14.3536 5.40374L15.7969 3.96044C15.1481 3.48705 14.3831 3.16825 13.5578 3.0503C13.3944 3.02694 13.2202 3.01443 13 3.00773V2.25C13 1.69772 12.5523 1.25 12 1.25C11.4477 1.25 11 1.69772 11 2.25V3.00773C10.7798 3.01443 10.6056 3.02694 10.4422 3.0503C8.57744 3.31681 7.0207 4.60879 6.41509 6.39254C6.3008 6.72916 6.22673 7.12423 6.07858 7.91436Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      d="M14 20.25V20.75C14 21.8546 13.1046 22.75 12 22.75C10.8955 22.75 10 21.8546 10 20.75V20.25H14Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      d="M3.70712 21.7071L21.7071 3.70711L20.2929 2.2929L2.29291 20.2929L3.70712 21.7071Z"
      fill="black"
      fillOpacity="0.8"
    />
  </svg>
);

export const Remove = RemoveIcon;

export const Minus = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    style={style}
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12.0001H8.99943L16 11.9998"
      stroke="black"
      strokeOpacity="0.8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Pause = PauseIcon;

export const Play = PlayIcon;

export const Delete = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    style={style}
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.61339 8.36413L12.2493 12.0001M12.2493 12.0001L15.886 15.6364M12.2493 12.0001L15.8857 8.36365M12.2493 12.0001L8.61328 15.6361"
      stroke="var(--on-surface)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRight = ({
  style,
  className,
  fill = 'var(--on-surface)',
}: {
  fill?: string;
  style?: React.CSSProperties;
  className?: string;
}) => (
  <svg
    style={style}
    width="10"
    height="24"
    viewBox="0 0 10 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fill={fill}
      d="M1.29289 6.70711C0.902369 6.31658 0.902369 5.68342 1.29289 5.29289C1.68342 4.90237 2.31658 4.90237 2.70711 5.29289L1.29289 6.70711ZM2.70711 18.7071C2.31658 19.0976 1.68342 19.0976 1.29289 18.7071C0.902368 18.3166 0.902368 17.6834 1.29289 17.2929L2.70711 18.7071ZM8 12L8.70711 11.2929C8.89464 11.4804 9 11.7348 9 12C9 12.2652 8.89464 12.5196 8.70711 12.7071L8 12ZM2.70711 5.29289L8.70711 11.2929L7.29289 12.7071L1.29289 6.70711L2.70711 5.29289ZM8.70711 12.7071L2.70711 18.7071L1.29289 17.2929L7.29289 11.2929L8.70711 12.7071Z"
    />
  </svg>
);

export const ChevronLeft = ({
  style,
  fill = 'var(--on-surface)',
}: {
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    style={style}
    width="10"
    height="24"
    viewBox="0 0 10 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={fill}
      d="M8.70711 6.70711C9.09763 6.31658 9.09763 5.68342 8.70711 5.29289C8.31658 4.90237 7.68342 4.90237 7.29289 5.29289L8.70711 6.70711ZM7.29289 18.7071C7.68342 19.0976 8.31658 19.0976 8.70711 18.7071C9.09763 18.3166 9.09763 17.6834 8.70711 17.2929L7.29289 18.7071ZM2 12L1.29289 11.2929C0.902369 11.6834 0.902369 12.3166 1.29289 12.7071L2 12ZM7.29289 5.29289L1.29289 11.2929L2.70711 12.7071L8.70711 6.70711L7.29289 5.29289ZM1.29289 12.7071L7.29289 18.7071L8.70711 17.2929L2.70711 11.2929L1.29289 12.7071Z"
    />
  </svg>
);

export const AddVolume = ({
  style,
  fill = 'var(--on-surface)',
}: {
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    style={style}
    width="33"
    height="24"
    viewBox="0 0 33 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11"
      cy="12"
      r="8"
      stroke="black"
      strokeOpacity="0.8"
      strokeWidth="2"
    />
    <circle
      cx="11"
      cy="12"
      r="2"
      stroke="black"
      strokeOpacity="0.8"
      strokeWidth="2"
    />
    <path
      d="M23 11.0002C22.4477 11.0002 22 11.4479 22 12.0002C22 12.5525 22.4477 13.0002 23 13.0002V11.0002ZM31.0001 13C31.5523 13 32 12.5522 32 11.9999C32 11.4477 31.5522 11 30.9999 11L31.0001 13ZM27.9997 8C27.9997 7.44772 27.552 7 26.9997 7C26.4474 7 25.9997 7.44772 25.9997 8H27.9997ZM25.9997 16C25.9997 16.5523 26.4474 17 26.9997 17C27.552 17 27.9997 16.5523 27.9997 16H25.9997ZM23 13.0002H26.9997V11.0002H23V13.0002ZM26.9997 13.0002L31.0001 13L30.9999 11L26.9996 11.0002L26.9997 13.0002ZM27.9997 12.0002V8H25.9997V12.0002H27.9997ZM25.9997 12.0002V16H27.9997V12.0002H25.9997Z"
      fill={fill}
    />
  </svg>
);

// TODO: replace with @base-ui/CheckIcon
export const Check = ({
  className,
  style,
  fill = 'var(--on-surface)',
}: {
  className?: string;
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    className={className}
    style={style}
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0079 6.29289C19.3984 6.68342 19.3984 7.31658 19.0079 7.70711L9.00789 17.7071C8.61736 18.0976 7.9842 18.0976 7.59367 17.7071L3.09367 13.2071C2.70315 12.8166 2.70315 12.1834 3.09367 11.7929C3.4842 11.4024 4.11736 11.4024 4.50789 11.7929L8.30078 15.5858L17.5937 6.29289C17.9842 5.90237 18.6174 5.90237 19.0079 6.29289Z"
      fill={fill}
    />
  </svg>
);

export const ChevronUp = ({
  style,
  fill = 'var(--on-surface)',
}: {
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    style={style}
    width="16"
    height="24"
    viewBox="0 0 16 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3132 15.5618C13.7146 15.9411 14.3475 15.9232 14.7268 15.5218C15.1061 15.1204 15.0882 14.4875 14.6868 14.1081L13.3132 15.5618ZM1.31316 14.1081C0.911756 14.4875 0.893858 15.1204 1.27319 15.5218C1.65252 15.9232 2.28543 15.9411 2.68684 15.5618L1.31316 14.1081ZM8 9.16496L8.68684 8.43815C8.30139 8.0739 7.69861 8.0739 7.31316 8.43815L8 9.16496ZM14.6868 14.1081L8.68684 8.43815L7.31316 9.89177L13.3132 15.5618L14.6868 14.1081ZM7.31316 8.43815L1.31316 14.1081L2.68684 15.5618L8.68684 9.89177L7.31316 8.43815Z"
      fill={fill}
    />
  </svg>
);

export const ChevronDown = ({
  style,
  fill = 'var(--on-surface)',
}: {
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    style={style}
    width="17"
    height="24"
    viewBox="0 0 17 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1142 8.43966C14.5157 8.06045 15.1486 8.07853 15.5278 8.48005C15.907 8.88157 15.8889 9.51447 15.4874 9.89368L14.1142 8.43966ZM2.11416 9.89368C1.71264 9.51447 1.69456 8.88157 2.07377 8.48005C2.45298 8.07853 3.08589 8.06045 3.48741 8.43966L2.11416 9.89368ZM8.80078 14.8333L9.48741 15.5604C9.10201 15.9243 8.49955 15.9243 8.11416 15.5604L8.80078 14.8333ZM15.4874 9.89368L9.48741 15.5604L8.11416 14.1063L14.1142 8.43966L15.4874 9.89368ZM8.11416 15.5604L2.11416 9.89368L3.48741 8.43966L9.48741 14.1063L8.11416 15.5604Z"
      fill={fill}
    />
  </svg>
);

export const Search = () => (
  <svg
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2071 13.7929C11.8166 13.4024 11.1834 13.4024 10.7929 13.7929C10.4024 14.1834 10.4024 14.8166 10.7929 15.2071L12.2071 13.7929ZM15.2929 19.7071C15.6834 20.0976 16.3166 20.0976 16.7071 19.7071C17.0976 19.3166 17.0976 18.6834 16.7071 18.2929L15.2929 19.7071ZM12 10.5C12 12.9853 9.98528 15 7.5 15V17C11.0899 17 14 14.0899 14 10.5H12ZM7.5 15C5.01472 15 3 12.9853 3 10.5H1C1 14.0899 3.91015 17 7.5 17V15ZM3 10.5C3 8.01472 5.01472 6 7.5 6V4C3.91015 4 1 6.91015 1 10.5H3ZM7.5 6C9.98528 6 12 8.01472 12 10.5H14C14 6.91015 11.0899 4 7.5 4V6ZM10.7929 15.2071L15.2929 19.7071L16.7071 18.2929L12.2071 13.7929L10.7929 15.2071Z"
      fill="var(--on-surface)"
    />
  </svg>
);

export const Close = ({
  style,
  fill = 'var(--on-surface)',
}: {
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    style={style}
    width="14"
    height="24"
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.07074 6.65716C2.68021 6.26664 2.04705 6.26664 1.65653 6.65716C1.266 7.04768 1.266 7.68085 1.65653 8.07137L3.07074 6.65716ZM10.9292 17.3436C11.3197 17.7342 11.9529 17.7341 12.3434 17.3436C12.7339 16.953 12.7339 16.3199 12.3433 15.9294L10.9292 17.3436ZM12.3431 8.07089C12.7336 7.68037 12.7336 7.0472 12.3431 6.65668C11.9525 6.26615 11.3194 6.26615 10.9289 6.65668L12.3431 8.07089ZM1.65642 15.9291C1.26589 16.3196 1.26589 16.9528 1.65642 17.3433C2.04694 17.7338 2.68011 17.7338 3.07063 17.3433L1.65642 15.9291ZM1.65653 8.07137L6.29245 12.7073L7.70666 11.2931L3.07074 6.65716L1.65653 8.07137ZM6.29248 12.7073L10.9292 17.3436L12.3433 15.9294L7.70663 11.2931L6.29248 12.7073ZM7.70666 12.7073L12.3431 8.07089L10.9289 6.65668L6.29245 11.2931L7.70666 12.7073ZM6.29245 11.2931L1.65642 15.9291L3.07063 17.3433L7.70666 12.7073L6.29245 11.2931Z"
      fill={fill}
    />
  </svg>
);

export const Cross = ({
  style,
  fill = 'var(--on-surface)',
}: {
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    style={style}
    width="16"
    height="24"
    viewBox="0 0 16 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.79289 16.7929C1.40237 17.1834 1.40237 17.8166 1.79289 18.2071C2.18342 18.5976 2.81658 18.5976 3.20711 18.2071L1.79289 16.7929ZM14.2071 7.20711C14.5976 6.81658 14.5976 6.18342 14.2071 5.79289C13.8166 5.40237 13.1834 5.40237 12.7929 5.79289L14.2071 7.20711ZM12.7929 18.2071C13.1834 18.5976 13.8166 18.5976 14.2071 18.2071C14.5976 17.8166 14.5976 17.1834 14.2071 16.7929L12.7929 18.2071ZM3.20711 5.79289C2.81658 5.40237 2.18342 5.40237 1.79289 5.79289C1.40237 6.18342 1.40237 6.81658 1.79289 7.20711L3.20711 5.79289ZM3.20711 18.2071L14.2071 7.20711L12.7929 5.79289L1.79289 16.7929L3.20711 18.2071ZM14.2071 16.7929L3.20711 5.79289L1.79289 7.20711L12.7929 18.2071L14.2071 16.7929Z"
      fill={fill}
    />
  </svg>
);

export const StyleEditor = () => (
  <svg
    width="20"
    height="32"
    viewBox="0 0 20 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.08594 5.14062L2.6875 15H0.632812L4.91406 3.625H6.22656L6.08594 5.14062ZM8.92969 15L5.52344 5.14062L5.375 3.625H6.69531L10.9922 15H8.92969ZM8.76562 10.7812V12.3359H2.57812V10.7812H8.76562ZM16.1719 13.3047L16.8125 9.25C16.8438 8.97917 16.8255 8.73438 16.7578 8.51562C16.6901 8.29688 16.5651 8.125 16.3828 8C16.2057 7.86979 15.9714 7.80208 15.6797 7.79688C15.4193 7.79167 15.1745 7.83594 14.9453 7.92969C14.7161 8.01823 14.5208 8.15104 14.3594 8.32812C14.2031 8.50521 14.099 8.72135 14.0469 8.97656L12.2109 8.98438C12.2422 8.54167 12.3724 8.15625 12.6016 7.82812C12.8359 7.49479 13.1302 7.22135 13.4844 7.00781C13.8438 6.78906 14.2292 6.63021 14.6406 6.53125C15.0573 6.42708 15.4635 6.3776 15.8594 6.38281C16.4323 6.39323 16.9401 6.51562 17.3828 6.75C17.8255 6.98438 18.1615 7.3151 18.3906 7.74219C18.625 8.16927 18.7135 8.6849 18.6562 9.28906L18.0391 13.0547C17.9922 13.3516 17.9583 13.6562 17.9375 13.9688C17.9219 14.276 17.9635 14.5729 18.0625 14.8594L18.0469 15L16.2266 15.0078C16.1484 14.7318 16.1094 14.4505 16.1094 14.1641C16.1094 13.8724 16.1302 13.5859 16.1719 13.3047ZM17.0234 9.85938L16.8359 11.0234L15.6172 11.0156C15.3672 11.0156 15.1094 11.0391 14.8438 11.0859C14.5833 11.1328 14.3385 11.2135 14.1094 11.3281C13.8802 11.4427 13.6875 11.599 13.5312 11.7969C13.375 11.9896 13.2786 12.2318 13.2422 12.5234C13.2161 12.7578 13.2422 12.9609 13.3203 13.1328C13.4036 13.2995 13.5286 13.4323 13.6953 13.5312C13.862 13.6302 14.0599 13.6823 14.2891 13.6875C14.5964 13.6927 14.8984 13.6328 15.1953 13.5078C15.4974 13.3828 15.7578 13.2057 15.9766 12.9766C16.2005 12.7422 16.3542 12.474 16.4375 12.1719L16.9297 13.0156C16.8151 13.3333 16.6536 13.625 16.4453 13.8906C16.2422 14.1562 16.0052 14.3854 15.7344 14.5781C15.4635 14.7708 15.1667 14.9193 14.8438 15.0234C14.526 15.1276 14.1979 15.1771 13.8594 15.1719C13.3906 15.1615 12.9635 15.0547 12.5781 14.8516C12.1927 14.6432 11.888 14.3542 11.6641 13.9844C11.4401 13.6146 11.3411 13.1875 11.3672 12.7031C11.3932 12.1562 11.5312 11.7005 11.7812 11.3359C12.0365 10.9661 12.362 10.6745 12.7578 10.4609C13.1589 10.2422 13.5964 10.0859 14.0703 9.99219C14.5443 9.89844 15.013 9.85156 15.4766 9.85156L17.0234 9.85938Z"
      fill="var(--on-surface)"
    />
    <rect x="6" y="24" width="8" height="8" rx="1" fill="var(--on-surface)" />
  </svg>
);

export const Calendar = () => (
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.59961 13H8.59961V11H6.59961V13Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      d="M10.5996 13V11H12.5996V13H10.5996Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      d="M14.5996 13H16.5996V11H14.5996V13Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      d="M10.5996 17V15H12.5996V17H10.5996Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      d="M14.5996 17H16.5996V15H14.5996V17Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      d="M6.59961 17V15H8.59961V17H6.59961Z"
      fill="black"
      fillOpacity="0.8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.59961 6C2.59961 4.34315 3.94276 3 5.59961 3H17.5996C19.2565 3 20.5996 4.34315 20.5996 6V18C20.5996 19.6569 19.2565 21 17.5996 21H5.59961C3.94276 21 2.59961 19.6569 2.59961 18V6ZM5.59961 5C5.04732 5 4.59961 5.44772 4.59961 6V7H18.5996V6C18.5996 5.44772 18.1519 5 17.5996 5H5.59961ZM18.5996 9H4.59961V18C4.59961 18.5523 5.04732 19 5.59961 19H17.5996C18.1519 19 18.5996 18.5523 18.5996 18V9Z"
      fill="black"
      fillOpacity="0.8"
    />
  </svg>
);

export const Plus = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    style={style}
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12.0004H8.99943M16 12L8.99943 12.0004M8.99943 12.0004V5M8.99943 12.0004V19"
      stroke="var(--on-surface)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Error = ErrorIcon;

export const ContentId = ({
  className,
  style,
  fill = 'var(--on-surface)',
  pending,
}: {
  className?: string;
  pending?: boolean;
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    className={className}
    style={style}
    width="28"
    height="24"
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.52789 16.176C7.36189 16.176 6.41955 15.8057 5.70089 15.065C4.98222 14.3243 4.62289 13.3307 4.62289 12.084C4.62289 10.8227 4.97489 9.82533 5.67889 9.092C6.38289 8.35867 7.33255 7.992 8.52789 7.992C9.49589 7.992 10.3172 8.24867 10.9919 8.762C11.6812 9.28267 12.0956 10.0197 12.2349 10.973H10.3539C10.2366 10.533 10.0166 10.1957 9.69389 9.961C9.37855 9.719 8.98989 9.598 8.52789 9.598C7.89722 9.598 7.40955 9.81433 7.06489 10.247C6.72755 10.6797 6.55889 11.292 6.55889 12.084C6.55889 12.876 6.72755 13.4883 7.06489 13.921C7.40955 14.3537 7.89722 14.57 8.52789 14.57C9.01189 14.57 9.42255 14.4307 9.75989 14.152C10.0972 13.8733 10.3099 13.4847 10.3979 12.986H12.2569C12.1396 13.998 11.7399 14.7827 11.0579 15.34C10.3686 15.8973 9.52522 16.176 8.52789 16.176ZM14.9652 16H13.1062V8.168H14.9652V16ZM16.157 8.168H19.369C20.6597 8.168 21.6497 8.51633 22.339 9.213C23.0283 9.90233 23.373 10.8593 23.373 12.084C23.373 13.3087 23.0283 14.2693 22.339 14.966C21.6497 15.6553 20.6597 16 19.369 16H16.157V8.168ZM18.016 14.427H19.336C20.0107 14.427 20.5277 14.2327 20.887 13.844C21.2537 13.448 21.437 12.8613 21.437 12.084C21.437 11.3067 21.2537 10.7237 20.887 10.335C20.5277 9.939 20.0107 9.741 19.336 9.741H18.016V14.427Z"
      fill={fill}
    />
    <rect
      x="2"
      y="2"
      stroke={fill}
      width="24"
      height="20"
      rx="4"
      strokeWidth="1.5"
      strokeDasharray={pending ? '2 2' : undefined}
    />
  </svg>
);

export const Mastering = ({
  className,
  style,
  fill = 'var(--on-surface)',
  pending,
}: {
  className?: string;
  pending?: boolean;
  fill?: string;
  style?: React.CSSProperties;
}) => (
  <svg
    className={className}
    style={style}
    width="28"
    height="24"
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5366 11.501L15.5596 8.168H18.3426V16H16.5716V13.701C16.5716 12.2417 16.5936 10.9803 16.6376 9.917C16.4983 10.4523 16.3223 11.0463 16.1096 11.699L14.7566 16H13.2386L11.8856 11.699C11.7243 11.1783 11.5519 10.588 11.3686 9.928C11.4053 11.16 11.4236 12.4177 11.4236 13.701V16H9.65259V8.168H12.4356L13.4696 11.534C13.6089 12.0107 13.7886 12.6597 14.0086 13.481C14.1846 12.7843 14.3606 12.1243 14.5366 11.501Z"
      fill={fill}
    />
    <rect
      x="2"
      y="2"
      width="24"
      height="20"
      rx="4"
      stroke={fill}
      strokeWidth="1.5"
      strokeDasharray={pending ? '2 2' : undefined}
    />
  </svg>
);

export const Return = ({
  style,
  fill = 'var(--on-surface)',
}: {
  fill: string;
  style?: React.CSSProperties;
}) => (
  <svg
    style={style}
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.66667 6L2 12M7.66667 18L2 12M2 12L19 12"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ColorBlock = ({
  style,
  fill = 'var(--on-surface)',
}: {
  fill: string;
  style?: React.CSSProperties;
}) => (
  <svg
    style={style}
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="3" width="18" height="18" rx="4" fill={fill} />
  </svg>
);
export const FontFace = ({
  style,
  fill = 'var(--on-surface)',
}: {
  fill: string;
  style?: React.CSSProperties;
}) => (
  <svg
    style={style}
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.98242 6.67578L2.73438 19H0.166016L5.51758 4.78125H7.1582L6.98242 6.67578ZM10.5371 19L6.2793 6.67578L6.09375 4.78125H7.74414L13.1152 19H10.5371ZM10.332 13.7266V15.6699H2.59766V13.7266H10.332ZM19.5898 16.8809L20.3906 11.8125C20.4297 11.474 20.4069 11.168 20.3223 10.8945C20.2376 10.6211 20.0814 10.4062 19.8535 10.25C19.6322 10.0872 19.3392 10.0026 18.9746 9.99609C18.6491 9.98958 18.3431 10.0449 18.0566 10.1621C17.7702 10.2728 17.526 10.4388 17.3242 10.6602C17.1289 10.8815 16.9987 11.1517 16.9336 11.4707L14.6387 11.4805C14.6777 10.9271 14.8405 10.4453 15.127 10.0352C15.4199 9.61849 15.7878 9.27669 16.2305 9.00977C16.6797 8.73633 17.1615 8.53776 17.6758 8.41406C18.1966 8.28385 18.7044 8.22201 19.1992 8.22852C19.9154 8.24154 20.5501 8.39453 21.1035 8.6875C21.6569 8.98047 22.0768 9.39388 22.3633 9.92773C22.6562 10.4616 22.7669 11.1061 22.6953 11.8613L21.9238 16.5684C21.8652 16.9395 21.8229 17.3203 21.7969 17.7109C21.7773 18.0951 21.8294 18.4661 21.9531 18.8242L21.9336 19L19.6582 19.0098C19.5605 18.6647 19.5117 18.3132 19.5117 17.9551C19.5117 17.5905 19.5378 17.2324 19.5898 16.8809ZM20.6543 12.5742L20.4199 14.0293L18.8965 14.0195C18.584 14.0195 18.2617 14.0488 17.9297 14.1074C17.6042 14.166 17.2982 14.2669 17.0117 14.4102C16.7253 14.5534 16.4844 14.7487 16.2891 14.9961C16.0938 15.237 15.9733 15.5397 15.9277 15.9043C15.8952 16.1973 15.9277 16.4512 16.0254 16.666C16.1296 16.8743 16.2858 17.0404 16.4941 17.1641C16.7025 17.2878 16.9499 17.3529 17.2363 17.3594C17.6204 17.3659 17.998 17.291 18.3691 17.1348C18.7467 16.9785 19.0723 16.7572 19.3457 16.4707C19.6257 16.1777 19.8177 15.8424 19.9219 15.4648L20.5371 16.5195C20.3939 16.9167 20.1921 17.2812 19.9316 17.6133C19.6777 17.9453 19.3815 18.2318 19.043 18.4727C18.7044 18.7135 18.3333 18.8991 17.9297 19.0293C17.5326 19.1595 17.1224 19.2214 16.6992 19.2148C16.1133 19.2018 15.5794 19.0684 15.0977 18.8145C14.6159 18.554 14.235 18.1927 13.9551 17.7305C13.6751 17.2682 13.5514 16.7344 13.584 16.1289C13.6165 15.4453 13.7891 14.8757 14.1016 14.4199C14.4206 13.9577 14.8275 13.5931 15.3223 13.3262C15.8236 13.0527 16.3704 12.8574 16.9629 12.7402C17.5553 12.623 18.1413 12.5645 18.7207 12.5645L20.6543 12.5742Z"
      fill={fill}
    />
  </svg>
);
